import ProductReviews from './ProductReviews'
import ServiceReviewBadge from './ServiceReviewBadge'


export { ProductReviews as default, ServiceReviewBadge }
